/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout.component';
import { getLanguages } from '../api/admin-translations.api';
import { go } from '@/modules/core/client/services/angular-compat';

export default function AdminTranslateFiles() {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadLanguages = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getLanguages();
      setLanguages(data);
    } catch (err) {
      setError('Failed to load languages');
      console.error('Failed to load languages:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLanguages();
  }, []);

  const handleTranslateClick = languageCode => {
    // Use Angular router to navigate without full page reload
    go('admin-translate-show', { language: languageCode });
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="container">
          <p>Loading languages...</p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="container">
        <div className="row" style={{ marginBottom: '1rem' }}>
          <div className="col-sm-12">
            <h2>All Translate Files</h2>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="panel panel-default">
          <div className="panel-heading" style={{ backgroundColor: '#f5f5f5' }}>
            <span style={{ marginRight: '10px' }}>📄</span>
            TRANSLATE FILES
          </div>
          <div className="panel-body">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Language</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {languages.map(lang => (
                  <tr key={lang.code}>
                    <td>
                      {lang.label}
                      {lang.code === 'en' && (
                        <span
                          className="label label-success"
                          style={{ marginLeft: '10px' }}
                        >
                          DEFAULT
                        </span>
                      )}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => handleTranslateClick(lang.code)}
                      >
                        Translate
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

AdminTranslateFiles.propTypes = {};
